<div class="section position-relative">
    <div class="section-top">
        <h3 class="section-title">Servicii</h3>
        <div clasas="section-top-actions">
            <button type="button" class="btn btn-sm btn-info pull-right ms-1" (click)="rerenderDT(false)">
                <i class="fa-solid fa-arrows-rotate"></i>
            </button>
            <button type="button" *ngIf="permissionsService.hasPermission('auth-module.ghiseu-settings.servicii.add')"
                class="btn btn-sm btn-primary pull-right ms-1" (click)="openAddDialog()">
                <i class="fa-solid fa-plus"></i>
                Adaugă
            </button>
        </div>
    </div>

    <div class="card-container p-2" *ngIf="showCard">
        <div class="row">
            <div class="col-md-6">
                <mat-form-field>
                    <mat-label>Activ</mat-label>
                    <mat-select [(ngModel)]="activeValue">
                        <mat-option *ngFor="let param of parameters" [value]="param.value">
                            {{ param.key }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-md-6">
                <mat-form-field>
                    <mat-label>Public</mat-label>
                    <mat-select [(ngModel)]="publicValue">
                        <mat-option *ngFor="let param of parameters" [value]="param.value">
                            {{ param.key }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <form [formGroup]="searchParamsForm">
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field>
                        <mat-label>Direcție</mat-label>
                        <mat-select formControlName="id_directie" (openedChange)="onDirectieSelectClosed()"
                            (selectionChange)="onDirectieChange($event.value)">
                            <mat-form-field class="px-2 w-100 sticky-input">
                                <input matInput [formControl]="directiiControl" (keydown)="$event.stopPropagation()"
                                    (click)="$event.stopPropagation()" />
                            </mat-form-field>

                            <mat-option *ngIf="filteredDirectii.length === 0" disabled>
                                <span>No results found</span>
                            </mat-option>

                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                            <mat-option *ngFor="let directie of filteredDirectii" [value]="directie.id">
                                {{ directie.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field>
                        <mat-label>Compartiment</mat-label>
                        <mat-select (openedChange)="onCompartimenteSelectClosed()" formControlName="id_compartiment">
                            <mat-form-field class="px-2 w-100 sticky-input">
                                <input matInput [formControl]="compartimenteControl"
                                    (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                            </mat-form-field>

                            <mat-option *ngIf="filteredCompartimente.length === 0" disabled>
                                <span>No results found</span>
                            </mat-option>

                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                            <mat-option *ngFor="let compartiment of filteredCompartimente" [value]="compartiment.id">
                                {{ compartiment.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </form>

        <div class="row w-100">
            <div class="col d-flex justify-content-start">
                <button (click)="toggleCard()" type="button" class="btn btn-sm btn-warning closeBtn">Închide</button>
            </div>
            <div class="col buttons-submit">
                <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                    Resetează
                </button>
                <button (click)="applyFilters()" type="submit" class="btn btn-sm btn-primary ms-2">
                    Aplică
                </button>
            </div>
        </div>


        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
            <div class="spinner position-absolute top-50 start-50 translate-middle">
                <mat-spinner></mat-spinner>
                <h3 class="mt-2">
                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                </h3>
            </div>
        </div>
    </div>
    <div class="col-sm-12 ps-3">
        <button type="button" class="btn btn-sm btn-default" (click)="toggleCard()" [class.active]="showCard">
            <i class="fa-solid fa-filter"></i> Filtre
        </button>
    </div>

    <div class="table-container position-relative">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100"></table>
    </div>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>